var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-n1",attrs:{"id":"SimpleSlider"}},[_c('v-img',{attrs:{"src":_vm.img}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }